/*
Presentation for the duplicate-account panel. The backend sends signal keys; support
reads Spanish, and has to be able to tell "same card and same phone" (one person with
two accounts) from "same doorway" (two people who live together).
*/

const REASON_LABELS = {
  phone: 'Mismo teléfono',
  card: 'Misma tarjeta',
  address: 'Misma dirección',
};

/* Unknown keys pass through rather than vanishing: the backend may learn a new signal
 * before this bundle is redeployed, and a raw key on screen beats a silent omission. */
const describeReasons = reasons => (Array.isArray(reasons) ? reasons : [])
  .map(reason => REASON_LABELS[reason] || reason);

/* A phone or a card belongs to a person; an address belongs to a household. An
 * address-only overlap is a lead, not an identification, and is not styled as one. */
const matchConfidence = (reasons) => {
  const list = Array.isArray(reasons) ? reasons : [];
  return list.includes('phone') || list.includes('card') ? 'high' : 'low';
};

module.exports = { REASON_LABELS, describeReasons, matchConfidence };
